"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CouldNotLoadDataView_1 = __importDefault(require("@react/web/Common/CouldNotLoadData/CouldNotLoadDataView"));
const FilterFormData_1 = require("@react/web/Listing/Filter/classes/FilterFormData");
const ListingOffersListView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/views/ListingOffersListView"));
const ListingOffersSkeletonView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/views/ListingOffersSkeletonView"));
const useSubscriptionListing_1 = __importDefault(require("@react/web/Listing/hooks/useSubscriptionListing"));
const FilterStateKeysEnum_1 = __importDefault(require("@react/web/Listing/Filter/FilterStateKeysEnum"));
const SubscriptionListing = () => {
    const { filterFormData, filteredListingOffers, noResultListingOffers, sortBy, handleFilterChange, handleSortingChange, handleMergedOfferClick, handleResetFilterClick, handleResetMergedOfferFilterClick, mergedCarListingOffer, loading, error, isSmallScreen, } = (0, useSubscriptionListing_1.default)();
    let filterCount = 0;
    if (filterFormData instanceof FilterFormData_1.FilterFormData) {
        Object.keys(filterFormData).forEach((key) => {
            if (key === FilterStateKeysEnum_1.default.contractLength && filterFormData.getSelectedContractLengths().length > 0) {
                filterCount += 1;
            }
            else {
                filterFormData[key].forEach((item) => {
                    if (item.active === true) {
                        filterCount += 1;
                    }
                });
            }
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        error !== null
            && react_1.default.createElement(CouldNotLoadDataView_1.default, { message: "N\u011Bco se pokazilo a nab\u00EDdka aut nen\u00ED moment\u00E1ln\u011B k dispozici." }),
        error === null && loading === true
            && react_1.default.createElement(ListingOffersSkeletonView_1.default, null),
        error === null && loading === false && filterFormData && filteredListingOffers
            && react_1.default.createElement(ListingOffersListView_1.default, { sortBy: sortBy, filteredListingOffers: filteredListingOffers, mergedCarListingOffer: mergedCarListingOffer, handleSortingChange: handleSortingChange, handleMergedOfferClick: handleMergedOfferClick, filterCount: filterCount, filterFormData: filterFormData, handleFilterChange: handleFilterChange, handleResetFilterClick: handleResetFilterClick, handleResetMergedOfferFilterClick: handleResetMergedOfferFilterClick, isSmallScreen: isSmallScreen, noResultListingOffers: noResultListingOffers })));
};
exports.default = SubscriptionListing;
